module.exports = __webpack_public_path__ + "static/media/save.8d4f3bfb.svg";